import { api } from './client'

// classId opsional: dengan kelas terpilih, hanya jadwal angkatan itu yang
// diambil — jadwal angkatan lain bukan urusan kelas yang sedang berjalan.
export const listSessions = (pid, classId) =>
  api
    .get(`/sessions/programs/${pid}`, classId ? { params: { class_id: classId } } : undefined)
    .then((r) => r.data)
export const listUpcomingSessions = (pid) =>
  api.get(`/sessions/programs/${pid}/upcoming`).then((r) => r.data)
export const createSession = (data) => api.post('/sessions', data).then((r) => r.data)
export const updateSession = (sessionId, data) =>
  api.put(`/sessions/${sessionId}`, data).then((r) => r.data)
export const deleteSession = (sessionId, { series = false } = {}) =>
  api.delete(`/sessions/${sessionId}${series ? '?series=true' : ''}`).then((r) => r.data)
export const startSessionQR = (sessionId) =>
  api.post(`/sessions/${sessionId}/qr/start`).then((r) => r.data)
export const endSession = (sessionId) =>
  api.post(`/sessions/${sessionId}/qr/stop`).then((r) => r.data)
export const getCurrentSessionQR = (sessionId) =>
  api.get(`/sessions/${sessionId}/qr/current`).then((r) => r.data)
export const joinZoom = (sessionId) =>
  api.post(`/sessions/${sessionId}/zoom/join`).then((r) => r.data)
export const startZoom = (sessionId) =>
  api.post(`/sessions/${sessionId}/zoom/start`).then((r) => r.data)
export const retryZoomMeeting = (sessionId) =>
  api.post(`/sessions/${sessionId}/zoom/meeting`).then((r) => r.data)
export const syncZoom = (sessionId) =>
  api.post(`/sessions/${sessionId}/zoom/sync`).then((r) => r.data)
export const getZoomParticipants = (sessionId) =>
  api.get(`/sessions/${sessionId}/zoom/participants`).then((r) => r.data)
export const listAttendees = (sessionId) =>
  api.get(`/sessions/${sessionId}/attendees`).then((r) => r.data)
export const getSession = (sessionId) =>
  api.get(`/sessions/${sessionId}`).then((r) => r.data)
export const getRsvp = (sessionId) =>
  api.get(`/sessions/${sessionId}/rsvp`).then((r) => r.data)
export const setRsvp = (sessionId, status) =>
  api.post(`/sessions/${sessionId}/rsvp`, { status }).then((r) => r.data)
export const scanAttendance = (token, geo = {}) =>
  api.post('/attendance/scan', { token, ...geo }).then((r) => r.data)
export const checkInWithCode = (code, geo = {}) =>
  api.post('/attendance/scan', { code, ...geo }).then((r) => r.data)
// Staf menandai/membatalkan kehadiran manual — untuk sesi yang QR-nya gagal
// atau absensinya dilakukan di kertas. Hanya untuk sesi yang sudah berjalan.
export const markAttendance = (sessionId, userId, note) =>
  api.post(`/sessions/${sessionId}/attendees`, { userId, note }).then((r) => r.data)
// Banyak peserta sekaligus → { created, already, notEnrolled } berisi userId.
export const markAttendanceBulk = (sessionId, userIds, note) =>
  api.post(`/sessions/${sessionId}/attendees/bulk`, { userIds, note }).then((r) => r.data)
export const removeAttendance = (sessionId, userId) =>
  api.delete(`/sessions/${sessionId}/attendees/${userId}`).then((r) => r.data)
// FR-32 session rating
export const rateSession = (sessionId, rating, comment) =>
  api.post(`/sessions/${sessionId}/rating`, { rating, comment }).then((r) => r.data)
export const listSessionRatings = (sessionId) =>
  api.get(`/sessions/${sessionId}/ratings`).then((r) => r.data)
